import type { VideoItem } from "@/types/video";

export const videos: VideoItem[] = [
  // ---------------- 电影 / movie ----------------
  {
    id: "mv-01",
    title: "流浪地球3",
    category: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "灾难", "冒险"],
    tags: ["热播", "4K高清", "高分"],
    rating: 8.7,
    popularity: 998,
    updatedAt: "2025-09-28",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20key%20art%2C%20an%20enormous%20planet%20engine%20glowing%20beneath%20a%20frozen%20earth%20sky%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20high%20contrast%20shadows%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv01&orientation=portrait",
    synopsis: "太阳危机进入最后阶段，地球在穿越木星引力带时遭遇前所未有的轨道偏移。人类联合政府启动最后的“火种计划”，一支年轻的宇航小队必须在四十八小时内重启沉睡的行星发动机，为整个文明赢得一线生机。",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健", "屈楚萧"],
  },
  {
    id: "mv-02",
    title: "长安三万里",
    category: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["动画", "历史", "剧情"],
    tags: ["高分", "经典", "口碑佳作"],
    rating: 8.9,
    popularity: 952,
    updatedAt: "2025-08-14",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20animated%20film%20poster%20key%20art%2C%20ancient%20chinese%20poet%20gazing%20at%20misty%20mountains%20and%20a%20great%20river%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20ink%20wash%20atmosphere%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv02&orientation=portrait",
    synopsis: "安史之乱后，年迈的高适回望与李白一生相交的岁月。从长安到扬州，从少年意气到山河破碎，两位诗人用诗句丈量了一个时代的兴衰。",
    director: "谢君伟",
    cast: ["杨天翔", "凌振赫", "贝骁"],
  },
  {
    id: "mv-03",
    title: "深海回响",
    category: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "剧情", "科幻"],
    tags: ["新片", "热播", "会员专享"],
    rating: 8.2,
    popularity: 887,
    updatedAt: "2025-09-20",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20underwater%20mystery%20movie%20poster%20key%20art%2C%20a%20lone%20deep%20sea%20submersible%20beam%20cutting%20through%20dark%20water%2C%20dramatic%20moody%20lighting%2C%20rich%20blue%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv03&orientation=portrait",
    synopsis: "一艘失联七年的深潜器突然在南海自动浮出水面，舱内记录仪留下了一段无法解释的声音。海洋生物学家与退役潜水员组成小队，下潜寻找答案。",
    director: "陈正道",
    cast: ["张震", "周冬雨", "王传君"],
  },
  {
    id: "mv-04",
    title: "边境线",
    category: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["动作", "犯罪", "悬疑"],
    tags: ["热播", "高分"],
    rating: 8.4,
    popularity: 861,
    updatedAt: "2025-09-12",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20action%20thriller%20movie%20poster%20key%20art%2C%20rain%20slicked%20border%20highway%20at%20night%20with%20car%20headlights%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv04&orientation=portrait",
    synopsis: "边境缉毒行动失败后，一名年轻警员被派往最偏远的口岸哨所。在那里，他逐渐发现整条补给线背后隐藏着更大的秘密。",
    director: "李骏",
    cast: ["彭于晏", "黄景瑜", "杜鹃"],
  },
  {
    id: "mv-05",
    title: "山海之间",
    category: "movie",
    year: 2022,
    region: "中国台湾",
    genres: ["剧情", "爱情", "家庭"],
    tags: ["经典", "口碑佳作"],
    rating: 8.6,
    popularity: 720,
    updatedAt: "2025-07-30",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20key%20art%2C%20coastal%20fishing%20village%20at%20golden%20sunset%20with%20distant%20mountains%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv05&orientation=portrait",
    synopsis: "离家十年的女儿回到海边小镇为父亲送葬，却在老屋里发现了母亲留下的三十七封信。山海之间，横亘着的是一场迟到了半生的和解。",
    director: "钟孟宏",
    cast: ["桂纶镁", "陈以文", "谢盈萱"],
  },
  {
    id: "mv-06",
    title: "代号·追风",
    category: "movie",
    year: 2025,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    tags: ["新片", "热播", "4K高清"],
    rating: 7.9,
    popularity: 905,
    updatedAt: "2025-09-30",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20hong%20kong%20action%20movie%20poster%20key%20art%2C%20neon%20lit%20street%20with%20silhouette%20of%20a%20runner%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv06&orientation=portrait",
    synopsis: "一名退休的特勤队员被迫重返一线，追踪一个能在城市监控网中“隐形”的犯罪组织。速度与智慧，是唯一的武器。",
    director: "林超贤",
    cast: ["古天乐", "刘青云", "文咏珊"],
  },
  {
    id: "mv-07",
    title: "寂静的证词",
    category: "movie",
    year: 2023,
    region: "韩国",
    genres: ["悬疑", "犯罪", "剧情"],
    tags: ["高分", "口碑佳作"],
    rating: 8.5,
    popularity: 768,
    updatedAt: "2025-08-22",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20korean%20crime%20thriller%20movie%20poster%20key%20art%2C%20empty%20courtroom%20corridor%20with%20cold%20fluorescent%20light%2C%20dramatic%20moody%20lighting%2C%20desaturated%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv07&orientation=portrait",
    synopsis: "一名辩护律师接手了一桩证据确凿的杀人案，却在翻阅卷宗时发现，所有证词都精准地指向同一个从未出现过的证人。",
    director: "李忠弼",
    cast: ["薛景求", "金喜爱", "李俊赫"],
  },
  {
    id: "mv-08",
    title: "星际信使",
    category: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "剧情", "冒险"],
    tags: ["热播", "4K高清"],
    rating: 8.1,
    popularity: 940,
    updatedAt: "2025-09-18",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20space%20sci-fi%20movie%20poster%20key%20art%2C%20lone%20astronaut%20silhouette%20before%20a%20giant%20glowing%20ringed%20planet%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv08&orientation=portrait",
    synopsis: "人类收到了一段来自四光年外的无线电信号，内容是一段从未被演奏过的钢琴曲。唯一的译码员发现，曲子里藏着人类的坐标。",
    director: "丹尼斯·维伦纽瓦",
    cast: ["艾米莉·布朗特", "奥斯卡·伊萨克"],
  },
  {
    id: "mv-09",
    title: "夏日大作战",
    category: "movie",
    year: 2021,
    region: "日本",
    genres: ["动画", "喜剧", "家庭"],
    tags: ["经典", "高分"],
    rating: 8.3,
    popularity: 660,
    updatedAt: "2025-06-25",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20anime%20summer%20movie%20poster%20key%20art%2C%20japanese%20countryside%20rice%20fields%20under%20bright%20blue%20sky%20with%20festival%20lanterns%2C%20warm%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv09&orientation=portrait",
    synopsis: "暑假第一天，少年误闯了祖母经营的老旅馆，也误闯进了一场横跨三代人的家族和解。蝉鸣、烟花，还有一个不肯说出口的秘密。",
    director: "细田守",
    cast: ["神木隆之介", "樱庭奈奈美"],
  },
  {
    id: "mv-10",
    title: "雾都迷案",
    category: "movie",
    year: 2022,
    region: "英国",
    genres: ["悬疑", "历史", "剧情"],
    tags: ["高分", "经典"],
    rating: 8.4,
    popularity: 690,
    updatedAt: "2025-07-11",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20victorian%20london%20mystery%20movie%20poster%20key%20art%2C%20foggy%20gaslit%20cobblestone%20street%20with%20a%20lone%20detective%20silhouette%2C%20dramatic%20moody%20lighting%2C%20desaturated%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv10&orientation=portrait",
    synopsis: "十九世纪末的伦敦，一位被警局除名的侦探受雇调查一桩剧院命案。随着线索深入，他发现自己追查的凶手，或许从未真正存在过。",
    director: "埃德加·赖特",
    cast: ["本尼迪克特", "奥利维亚·科尔曼"],
  },
  {
    id: "mv-11",
    title: "热浪",
    category: "movie",
    year: 2025,
    region: "美国",
    genres: ["灾难", "剧情", "冒险"],
    tags: ["新片", "热播"],
    rating: 7.7,
    popularity: 830,
    updatedAt: "2025-09-26",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20disaster%20movie%20poster%20key%20art%2C%20blazing%20orange%20wildfire%20horizon%20behind%20a%20city%20skyline%2C%20dramatic%20moody%20lighting%2C%20rich%20warm%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv11&orientation=portrait",
    synopsis: "极端高温席卷西海岸，电网濒临崩溃。一名气象学家必须在发布撤离令和保住自己的研究数据之间做出选择。",
    director: "罗兰·艾默里奇",
    cast: ["杰克·吉伦哈尔", "桑德拉·布洛克"],
  },
  {
    id: "mv-12",
    title: "胡同里的春天",
    category: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭", "喜剧"],
    tags: ["口碑佳作", "经典"],
    rating: 8.2,
    popularity: 615,
    updatedAt: "2025-07-05",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20warm%20family%20drama%20movie%20poster%20key%20art%2C%20old%20beijing%20hutong%20alley%20in%20spring%20with%20blossoming%20trees%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv12&orientation=portrait",
    synopsis: "老胡同要拆迁了，守着一间小面馆的爷爷和从国外回来的孙女，用一整个春天，重新认识了这个家。",
    director: "张栾",
    cast: ["李雪健", "奚美娟", "张子枫"],
  },
  {
    id: "mv-13",
    title: "午夜信箱",
    category: "movie",
    year: 2024,
    region: "日本",
    genres: ["爱情", "奇幻", "剧情"],
    tags: ["高分", "口碑佳作"],
    rating: 8.6,
    popularity: 712,
    updatedAt: "2025-08-30",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romantic%20fantasy%20movie%20poster%20key%20art%2C%20old%20red%20postbox%20glowing%20under%20a%20quiet%20midnight%20snowfall%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv13&orientation=portrait",
    synopsis: "城市角落有一只只在午夜开启的旧信箱。投进去的信，会寄到十年前或十年后的某个人手里。而她的信，总是寄给同一个人。",
    director: "土井裕泰",
    cast: ["佐藤健", "长泽雅美"],
  },
  {
    id: "mv-14",
    title: "荒野法则",
    category: "movie",
    year: 2022,
    region: "美国",
    genres: ["冒险", "剧情", "动作"],
    tags: ["经典", "4K高清"],
    rating: 8.0,
    popularity: 640,
    updatedAt: "2025-06-18",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wilderness%20adventure%20movie%20poster%20key%20art%2C%20rugged%20snowy%20mountain%20pass%20with%20a%20lone%20hiker%20silhouette%2C%20dramatic%20moody%20lighting%2C%20cool%20desaturated%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv14&orientation=portrait",
    synopsis: "一场雪崩让登山队全军覆没，唯一的幸存者必须带着队友留下的地图，穿越三百公里无人区，把真相带回文明世界。",
    director: "亚历杭德罗",
    cast: ["汤姆·哈迪", "凯瑞·穆里根"],
  },
  {
    id: "mv-15",
    title: "纸飞机",
    category: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "青春"],
    tags: ["口碑佳作", "新片"],
    rating: 8.1,
    popularity: 588,
    updatedAt: "2025-07-22",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20coming%20of%20age%20drama%20movie%20poster%20key%20art%2C%20teenagers%20on%20a%20school%20rooftop%20releasing%20paper%20planes%20at%20dusk%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv15&orientation=portrait",
    synopsis: "高考前的最后一个学期，四个成绩普通的少年约定：不管结果如何，都要把写给未来的信折成纸飞机，扔上同一片屋顶。",
    director: "白雪",
    cast: ["周也", "刘昊然", "文淇"],
  },
  {
    id: "mv-16",
    title: "断线",
    category: "movie",
    year: 2024,
    region: "韩国",
    genres: ["悬疑", "科幻", "犯罪"],
    tags: ["新片", "热播", "会员专享"],
    rating: 7.8,
    popularity: 795,
    updatedAt: "2025-09-08",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20cyber%20thriller%20movie%20poster%20key%20art%2C%20glitching%20server%20room%20with%20cascading%20data%20and%20a%20lone%20figure%2C%20dramatic%20moody%20lighting%2C%20cool%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv16&orientation=portrait",
    synopsis: "全国通信网络在一次升级后集体宕机，一名程序员发现，这场“事故”其实是一场精确到秒的预谋。",
    director: "延尚昊",
    cast: ["刘亚仁", "朴正民"],
  },
  {
    id: "mv-17",
    title: "山河故人志",
    category: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["历史", "战争", "剧情"],
    tags: ["高分", "经典"],
    rating: 8.7,
    popularity: 605,
    updatedAt: "2025-05-28",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20historical%20war%20epic%20movie%20poster%20key%20art%2C%20misty%20mountain%20battlefield%20at%20dawn%20with%20distant%20banners%2C%20dramatic%20moody%20lighting%2C%20desaturated%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv17&orientation=portrait",
    synopsis: "战火中，一支测绘小队奉命穿越敌占区绘制地图。他们背负的不是枪炮，而是一整个民族对山河的记忆。",
    director: "管虎",
    cast: ["张译", "段奕宏", "王千源"],
  },
  {
    id: "mv-18",
    title: "第九夜",
    category: "movie",
    year: 2025,
    region: "中国香港",
    genres: ["恐怖", "悬疑"],
    tags: ["新片", "会员专享"],
    rating: 7.3,
    popularity: 742,
    updatedAt: "2025-09-24",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20horror%20mystery%20movie%20poster%20key%20art%2C%20dimly%20lit%20old%20apartment%20corridor%20with%20flickering%20light%2C%20dramatic%20moody%20lighting%2C%20cold%20desaturated%20color%20grading%2C%20deep%20shadows%2C%20professional%20film%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=mv18&orientation=portrait",
    synopsis: "搬进老公寓的第九个夜晚，租客开始收到来自隔壁的敲墙声。而物业告诉他，隔壁那间房，已经空了二十年。",
    director: "陈可辛",
    cast: ["邓丽欣", "姜皓文"],
  },

  // ---------------- 电视剧 / tv ----------------
  {
    id: "tv-01",
    title: "长夜将明",
    category: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "都市"],
    tags: ["热播", "高分", "4K高清"],
    rating: 8.8,
    popularity: 990,
    updatedAt: "2025-09-29",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20series%20poster%20key%20art%2C%20rainy%20city%20street%20at%20night%20with%20a%20lone%20detective%20under%20a%20streetlight%2C%20dramatic%20moody%20lighting%2C%20cool%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv01&orientation=portrait",
    synopsis: "一桩尘封十五年的悬案因一段匿名录音重启，刑警队长与当年唯一的目击者联手追凶。真相越近，长夜越深，但黎明终会到来。",
    director: "费振翔",
    cast: ["秦昊", "谭卓", "王景春"],
    episodes: 32,
    updateStatus: "连载",
  },
  {
    id: "tv-02",
    title: "锦绣长安",
    category: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "历史", "剧情"],
    tags: ["热播", "会员专享", "高分"],
    rating: 8.5,
    popularity: 968,
    updatedAt: "2025-09-25",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20chinese%20historical%20costume%20drama%20poster%20key%20art%2C%20ancient%20palace%20courtyard%20with%20red%20lanterns%20and%20misty%20roofs%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv02&orientation=portrait",
    synopsis: "初唐年间，出身寒门的女官与年轻的少卿卷入一场关乎朝局的漕运贪墨案，在权谋与情义之间，她们共同守护着这座城。",
    director: "李慧珠",
    cast: ["赵丽颖", "白宇", "刘奕君"],
    episodes: 45,
    updateStatus: "完结",
  },
  {
    id: "tv-03",
    title: "都市夜归人",
    category: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "爱情", "家庭"],
    tags: ["热播", "口碑佳作"],
    rating: 8.2,
    popularity: 902,
    updatedAt: "2025-09-22",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20urban%20life%20drama%20series%20poster%20key%20art%2C%20glowing%20city%20skyline%20at%20night%20through%20an%20apartment%20window%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv03&orientation=portrait",
    synopsis: "五个住在同一栋公寓、却几乎不曾照面的陌生人，因为一部深夜电梯的故障，开始走进彼此的生活。",
    director: "沈严",
    cast: ["雷佳音", "殷桃", "宋佳"],
    episodes: 36,
    updateStatus: "连载",
  },
  {
    id: "tv-04",
    title: "时间闭环",
    category: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "剧情"],
    tags: ["高分", "经典"],
    rating: 8.6,
    popularity: 815,
    updatedAt: "2025-08-16",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20time%20travel%20sci-fi%20series%20poster%20key%20art%2C%20a%20figure%20standing%20before%20a%20giant%20glowing%20clock%20portal%2C%20dramatic%20moody%20lighting%2C%20cool%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv04&orientation=portrait",
    synopsis: "一支科研团队意外打开了时间闭环，每一次回溯都会让现实更糟一点。他们必须在彻底失控前，找到最初的那个错误。",
    director: "辛爽",
    cast: ["王凯", "李沁", "张颂文"],
    episodes: 24,
    updateStatus: "完结",
  },
  {
    id: "tv-05",
    title: "白露为霜",
    category: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "爱情", "玄幻"],
    tags: ["新片", "热播", "会员专享"],
    rating: 7.9,
    popularity: 933,
    updatedAt: "2025-09-27",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20chinese%20fantasy%20romance%20drama%20poster%20key%20art%2C%20misty%20bamboo%20forest%20with%20floating%20white%20petals%20and%20a%20flowing%20robe%20figure%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv05&orientation=portrait",
    synopsis: "药谷弟子与冷面值守神君因一味失传的古方结缘，一个想救人，一个背负天规，命运却将他们推向同一场天劫。",
    director: "尹涛",
    cast: ["杨紫", "王鹤棣", "陈都灵"],
    episodes: 40,
    updateStatus: "连载",
  },
  {
    id: "tv-06",
    title: "急诊科日记",
    category: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["医疗", "都市", "剧情"],
    tags: ["口碑佳作", "高分"],
    rating: 8.4,
    popularity: 780,
    updatedAt: "2025-09-15",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20series%20poster%20key%20art%2C%20bright%20hospital%20emergency%20corridor%20with%20rushing%20staff%2C%20clean%20cool%20lighting%2C%20desaturated%20color%20grading%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv06&orientation=portrait",
    synopsis: "从实习医生到主治，五年急诊科的日日夜夜。每一个被推进抢救室的人，背后都有一段无法被病历记录的人生。",
    director: "张黎",
    cast: ["靳东", "海清", "张嘉益"],
    episodes: 38,
    updateStatus: "完结",
  },
  {
    id: "tv-07",
    title: "暗海寻踪",
    category: "tv",
    year: 2025,
    region: "英国",
    genres: ["悬疑", "犯罪", "剧情"],
    tags: ["热播", "会员专享"],
    rating: 8.3,
    popularity: 856,
    updatedAt: "2025-09-23",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20british%20mystery%20series%20poster%20key%20art%2C%20stormy%20harbour%20town%20with%20a%20lighthouse%20and%20rough%20sea%2C%20dramatic%20moody%20lighting%2C%20desaturated%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv07&orientation=portrait",
    synopsis: "一座海岛小镇，十年前失踪的女孩，如今以一段漂流瓶里的录音重新出现。警探回到家乡，揭开的却是整个小镇的沉默。",
    director: "苏珊娜·比尔",
    cast: ["奥利维亚·科尔曼", "大卫·田纳特"],
    episodes: 8,
    updateStatus: "连载",
  },
  {
    id: "tv-08",
    title: "青春合伙人",
    category: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "都市", "爱情"],
    tags: ["口碑佳作", "热播"],
    rating: 7.8,
    popularity: 712,
    updatedAt: "2025-07-19",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20youth%20startup%20drama%20series%20poster%20key%20art%2C%20sunlit%20modern%20office%20loft%20with%20young%20team%20brainstorming%2C%20warm%20bright%20lighting%2C%20rich%20color%20grading%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv08&orientation=portrait",
    synopsis: "四个刚毕业的年轻人凑钱租下半间办公室，决定做一款没人看好的产品。创业的第一课，是学会和彼此和解。",
    director: "刘俊杰",
    cast: ["白敬亭", "田曦薇", "檀健次"],
    episodes: 30,
    updateStatus: "完结",
  },
  {
    id: "tv-09",
    title: "谍影重重之城",
    category: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["谍战", "历史", "悬疑"],
    tags: ["高分", "经典"],
    rating: 8.7,
    popularity: 745,
    updatedAt: "2025-06-12",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20spy%20thriller%20series%20poster%20key%20art%2C%20rainy%201940s%20city%20alley%20with%20a%20coat%20wearing%20figure%20under%20a%20lamp%2C%20dramatic%20moody%20lighting%2C%20desaturated%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv09&orientation=portrait",
    synopsis: "孤岛时期，潜伏在敌人核心部门的情报员用三年时间，把一份足以改变战局的名单，一个名字一个名字地送了出去。",
    director: "张永新",
    cast: ["胡歌", "刘奕君", "王鸥"],
    episodes: 42,
    updateStatus: "完结",
  },
  {
    id: "tv-10",
    title: "一起晚餐吧",
    category: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "家庭", "爱情"],
    tags: ["热播", "口碑佳作"],
    rating: 8.0,
    popularity: 690,
    updatedAt: "2025-08-08",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20warm%20family%20drama%20series%20poster%20key%20art%2C%20cozy%20dining%20table%20with%20home%20cooked%20dishes%20in%20warm%20evening%20light%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv10&orientation=portrait",
    synopsis: "一间开在巷口的深夜食堂，一张永远给客人留着位置的圆桌。每个推门进来的人，都带着一个想被听见的故事。",
    director: "陈铭章",
    cast: ["黄磊", "海清", "张子枫"],
    episodes: 34,
    updateStatus: "连载",
  },
  {
    id: "tv-11",
    title: "迷雾之城",
    category: "tv",
    year: 2025,
    region: "韩国",
    genres: ["悬疑", "犯罪", "科幻"],
    tags: ["新片", "热播", "4K高清"],
    rating: 8.2,
    popularity: 884,
    updatedAt: "2025-09-21",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20korean%20mystery%20sci-fi%20series%20poster%20key%20art%2C%20neon%20lit%20seoul%20street%20covered%20in%20thick%20fog%2C%20dramatic%20moody%20lighting%2C%20cool%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv11&orientation=portrait",
    synopsis: "一场浓雾笼罩首尔，雾中的人会短暂地失去对时间的感知。刑警发现，最近连环案件的所有嫌疑人，都在雾里“消失”过。",
    director: "金成勋",
    cast: ["李政宰", "全智贤", "朴叙俊"],
    episodes: 12,
    updateStatus: "连载",
  },
  {
    id: "tv-12",
    title: "旧城纪事",
    category: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["历史", "家庭", "剧情"],
    tags: ["高分", "口碑佳作"],
    rating: 8.5,
    popularity: 640,
    updatedAt: "2025-06-30",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20period%20family%20saga%20series%20poster%20key%20art%2C%20old%20chinese%20town%20street%20with%20wooden%20shops%20at%20dusk%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv12&orientation=portrait",
    synopsis: "从八十年代到新世纪初，一户普通人家在旧城改造中经历了三次搬迁。房子在变，一家人的牵挂却始终没变。",
    director: "孔笙",
    cast: ["王凯", "童瑶", "刘琳"],
    episodes: 40,
    updateStatus: "完结",
  },
  {
    id: "tv-13",
    title: "第七封信",
    category: "tv",
    year: 2024,
    region: "日本",
    genres: ["悬疑", "爱情", "剧情"],
    tags: ["会员专享", "口碑佳作"],
    rating: 8.1,
    popularity: 668,
    updatedAt: "2025-08-20",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20mystery%20romance%20series%20poster%20key%20art%2C%20quiet%20library%20with%20stacked%20letters%20and%20warm%20lamp%20light%2C%20warm%20moody%20lighting%2C%20muted%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv13&orientation=portrait",
    synopsis: "作家去世后，编辑整理遗物时发现七封未寄出的信。每一封都指向同一个人，而那个人，正坐在编辑的办公室里。",
    director: "冢原亚由子",
    cast: ["绫濑遥", "高桥一生", "松下洸平"],
    episodes: 10,
    updateStatus: "完结",
  },
  {
    id: "tv-14",
    title: "北纬四十度",
    category: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "悬疑", "剧情"],
    tags: ["新片", "热播"],
    rating: 7.9,
    popularity: 776,
    updatedAt: "2025-09-19",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20modern%20suspense%20series%20poster%20key%20art%2C%20empty%20highway%20cutting%20through%20vast%20northern%20plain%20at%20dusk%2C%20dramatic%20moody%20lighting%2C%20cool%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv14&orientation=portrait",
    synopsis: "一辆长途货车上，三个互不相识的陌生人，因为同一段公路和同一桩旧案，被绑上了同一条命运的路线。",
    director: "刁亦男",
    cast: ["段奕宏", "周冬雨", "廖凡"],
    episodes: 28,
    updateStatus: "连载",
  },
  {
    id: "tv-15",
    title: "万家灯火",
    category: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["家庭", "都市", "爱情"],
    tags: ["口碑佳作", "经典"],
    rating: 8.3,
    popularity: 622,
    updatedAt: "2025-06-05",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20warm%20urban%20family%20series%20poster%20key%20art%2C%20residential%20buildings%20glowing%20with%20window%20lights%20at%20night%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=tv15&orientation=portrait",
    synopsis: "一条老街，六户人家，二十年的家长里短。有人离开，有人回来，而窗子里的那盏灯，始终为晚归的人亮着。",
    director: "汪俊",
    cast: ["孙俪", "张译", "闫妮"],
    episodes: 42,
    updateStatus: "完结",
  },

  // ---------------- 综艺 / variety ----------------
  {
    id: "va-01",
    title: "向往的远方",
    category: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["真人秀", "生活"],
    tags: ["热播", "4K高清", "高分"],
    rating: 8.4,
    popularity: 928,
    updatedAt: "2025-09-26",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20reality%20show%20poster%20key%20art%2C%20idyllic%20countryside%20farmhouse%20with%20golden%20field%20and%20warm%20sunset%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va01&orientation=portrait",
    synopsis: "六位嘉宾每周去往一个陌生的小村庄，用一整天的时间，体验最真实的劳作与生活。远方不一定很远，慢下来才看得见。",
    director: "王征宇",
    cast: ["黄磊", "何炅", "彭昱畅", "张子枫"],
    platform: "芒果TV",
    playStatus: "更新至第10期",
  },
  {
    id: "va-02",
    title: "音乐现场",
    category: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["音乐", "竞技"],
    tags: ["热播", "高分"],
    rating: 8.6,
    popularity: 905,
    updatedAt: "2025-09-28",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20live%20music%20show%20poster%20key%20art%2C%20concert%20stage%20bathed%20in%20orange%20spotlights%20with%20silhouetted%20singer%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va02&orientation=portrait",
    synopsis: "每期一位歌手，一支乐队，一场没有修音的现场。把最真实的声音和最赤诚的情绪，原封不动地交还给观众。",
    director: "洪涛",
    cast: ["华晨宇", "周深", "单依纯"],
    platform: "湖南卫视",
    playStatus: "更新至第8期",
  },
  {
    id: "va-03",
    title: "喜剧一周",
    category: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "脱口秀"],
    tags: ["热播", "口碑佳作"],
    rating: 8.2,
    popularity: 862,
    updatedAt: "2025-09-20",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20comedy%20talk%20show%20poster%20key%20art%2C%20warm%20stage%20with%20a%20single%20microphone%20and%20spotlight%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va03&orientation=portrait",
    synopsis: "一周的疲惫，交给一群最会讲段子的人。生活里的糟心事，被他们讲成了让人笑出眼泪的故事。",
    director: "叶烽",
    cast: ["李诞", "徐志胜", "何广智"],
    platform: "腾讯视频",
    playStatus: "已完结",
  },
  {
    id: "va-04",
    title: "极限挑战赛",
    category: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["竞技", "真人秀"],
    tags: ["新片", "热播", "会员专享"],
    rating: 7.9,
    popularity: 890,
    updatedAt: "2025-09-27",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20outdoor%20competition%20show%20poster%20key%20art%2C%20mountain%20obstacle%20course%20with%20runners%20at%20dawn%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va04&orientation=portrait",
    synopsis: "十二名选手，八道关卡，一座无人岛。没有剧本，没有重来，只有最原始的体力、智力与团队意志的较量。",
    director: "严敏",
    cast: ["孙红雷", "黄渤", "张艺兴", "王迅"],
    platform: "优酷",
    playStatus: "更新至第6期",
  },
  {
    id: "va-05",
    title: "深夜对话",
    category: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["访谈", "纪实"],
    tags: ["高分", "口碑佳作"],
    rating: 8.7,
    popularity: 720,
    updatedAt: "2025-09-10",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20late%20night%20interview%20show%20poster%20key%20art%2C%20two%20chairs%20under%20a%20single%20warm%20lamp%20in%20a%20dark%20studio%2C%20warm%20moody%20lighting%2C%20muted%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va05&orientation=portrait",
    synopsis: "凌晨之后，摄像机还在转。一档不追求金句、只追求真诚的访谈节目，听那些很少被认真听完的人生。",
    director: "许知远",
    cast: ["许知远", "陈晓卿", "梁文道"],
    platform: "B站",
    playStatus: "更新至第12期",
  },
  {
    id: "va-06",
    title: "美味奇遇",
    category: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["生活", "纪实"],
    tags: ["热播", "4K高清"],
    rating: 8.3,
    popularity: 806,
    updatedAt: "2025-09-24",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20food%20documentary%20show%20poster%20key%20art%2C%20rustic%20night%20street%20food%20stall%20with%20steaming%20dishes%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va06&orientation=portrait",
    synopsis: "从清晨的菜市场到深夜的大排档，六位主厨带着各自的家乡味出发，去寻找那些藏在烟火气里的中国故事。",
    director: "陈晓卿",
    cast: ["李立宏", "蔡澜", "沈宏非"],
    platform: "央视",
    playStatus: "更新至第9期",
  },
  {
    id: "va-07",
    title: "舞台之上",
    category: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["竞技", "音乐"],
    tags: ["热播", "会员专享"],
    rating: 8.1,
    popularity: 774,
    updatedAt: "2025-09-06",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dance%20competition%20show%20poster%20key%20art%2C%20dramatic%20stage%20with%20a%20spotlight%20on%20a%20lone%20dancer%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va07&orientation=portrait",
    synopsis: "来自全国各地的舞者同台竞技，民族舞、街舞、现代舞在同一个舞台碰撞。每一次登台，都是一次不留退路的表达。",
    director: "陆伟",
    cast: ["王一博", "刘宪华", "宋茜"],
    platform: "爱奇艺",
    playStatus: "已完结",
  },
  {
    id: "va-08",
    title: "出发吧少年",
    category: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["真人秀", "亲子"],
    tags: ["新片", "热播"],
    rating: 7.8,
    popularity: 812,
    updatedAt: "2025-09-25",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20travel%20reality%20show%20poster%20key%20art%2C%20young%20people%20backpacking%20on%20a%20winding%20mountain%20road%20at%20sunrise%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va08&orientation=portrait",
    synopsis: "五个性格迥异的少年，带着有限的预算和一张手绘地图，用三十天的时间，完成一场没有大人陪同的旅行。",
    director: "吴梦知",
    cast: ["何炅", "汪涵", "彭昱畅"],
    platform: "芒果TV",
    playStatus: "更新至第7期",
  },
  {
    id: "va-09",
    title: "科学有意思",
    category: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["纪实", "访谈"],
    tags: ["高分", "经典"],
    rating: 8.5,
    popularity: 640,
    updatedAt: "2025-07-14",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20science%20education%20show%20poster%20key%20art%2C%20dark%20lab%20with%20glowing%20blue%20experiment%20equipment%20and%20charts%2C%20dramatic%20moody%20lighting%2C%20cool%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va09&orientation=portrait",
    synopsis: "把最前沿的科学问题，讲成最下饭的故事。从量子计算到深海生物，每一个“原来如此”，都值得被认真对待。",
    director: "张腾岳",
    cast: ["张腾岳", "李永乐", "严伯钧"],
    platform: "央视",
    playStatus: "已完结",
  },
  {
    id: "va-10",
    title: "城市玩家",
    category: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["竞技", "生活"],
    tags: ["口碑佳作", "热播"],
    rating: 8.0,
    popularity: 706,
    updatedAt: "2025-08-28",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20city%20game%20show%20poster%20key%20art%2C%20busy%20metropolitan%20crossing%20at%20night%20with%20neon%20signs%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va10&orientation=portrait",
    synopsis: "把整座城市当成一张棋盘，嘉宾们需要依靠线索和陌生人帮助，在限定时间内完成一场横跨城市的解谜之旅。",
    director: "陈伟",
    cast: ["黄明昊", "范丞丞", "杨迪"],
    platform: "腾讯视频",
    playStatus: "已完结",
  },
  {
    id: "va-11",
    title: "我们的乐队",
    category: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["音乐", "竞技"],
    tags: ["新片", "热播", "会员专享"],
    rating: 8.2,
    popularity: 838,
    updatedAt: "2025-09-22",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20rock%20band%20show%20poster%20key%20art%2C%20band%20silhouettes%20on%20a%20smoky%20stage%20under%20amber%20lights%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20high%20contrast%20shadows%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va11&orientation=portrait",
    synopsis: "素人乐手两两组队，从零开始磨合一支乐队。有人为了梦想，有人为了证明，舞台亮起时，只剩下音乐本身。",
    director: "车澈",
    cast: ["谢霆锋", "王俊凯", "萧敬腾"],
    platform: "爱奇艺",
    playStatus: "更新至第5期",
  },
  {
    id: "va-12",
    title: "老友开饭啦",
    category: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["真人秀", "喜剧"],
    tags: ["口碑佳作", "经典"],
    rating: 8.1,
    popularity: 632,
    updatedAt: "2025-06-20",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20friends%20dinner%20reality%20show%20poster%20key%20art%2C%20lively%20outdoor%20dinner%20table%20with%20lanterns%20and%20laughing%20guests%2C%20warm%20moody%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20depth%2C%20professional%20tv%20marketing%20visual%2C%20premium%20quality%2C%20no%20text&width=400&height=560&seq=va12&orientation=portrait",
    synopsis: "几位相识多年的老友，轮流做东请客。饭桌上有争论、有爆料、有眼泪，但最多的还是那种只属于老友的松弛。",
    director: "王鑫璇",
    cast: ["邓超", "陈赫", "鹿晗"],
    platform: "浙江卫视",
    playStatus: "已完结",
  },
];

export default videos;